import { useSEO } from "../hook";

export const H1 = () => {
	const { seoMetaTags } = useSEO();
	return <h1>{seoMetaTags?.h1}</h1>
}
